/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Box, Typography
} from '@material-ui/core';
import Dimmer from '+/Dimmer';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const MatrixV2 = props => {
    const { match, authorization } = props;
    const { property_id } = match.params;

    const [isLoading, setIsLoading] = useState(true);
    const [iframeUrl, setIframeUrl] = useState('');
    const [fetchError, setFetchError] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const fetchIframeContent = async () => {
            setIsLoading(true);
            setFetchError(null);

            if (iframeUrl && iframeUrl.startsWith('blob:')) {
                URL.revokeObjectURL(iframeUrl);
                setIframeUrl('');
            }

            try {
                const _url = new URL(baseURL);
                _url.pathname = `/properties/${property_id}/reports/matrix-and-leasing`;
                const url = _url.toString();
                const headers = {
                    'Accept': 'text/html',
                    'Content-Type': 'text/html'
                };

                if (authorization) {
                    headers['Authorization'] = `Bearer ${authorization}`;
                }

                const response = await fetch(url, {
                    method: 'GET',
                    headers,
                    credentials: 'include',
                    mode: 'cors'
                });

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

                const html = await response.text();
                const blob = new Blob([html], { type: 'text/html' });
                const blobUrl = URL.createObjectURL(blob);

                if (isMounted) {
                    window.scrollTo(0, 0);
                    setIframeUrl(blobUrl);
                    setIsLoading(false);
                }
            }
            catch (error) {
                if (isMounted) {
                    setFetchError(error.message);
                    setIsLoading(false);
                }
            }
        };

        fetchIframeContent();

        return () => {
            isMounted = false;
            if (iframeUrl && iframeUrl.startsWith('blob:')) {
                URL.revokeObjectURL(iframeUrl);
            }
        };
    }, [property_id, authorization]);

    const handleIframeLoad = () => {
        console.log('Iframe loaded');
    };

    const handleIframeError = () => {
        setFetchError('Error: Cannot load the data. Please try again later.');
    };

    const styles = {
        container: {
            width: '100%',
            position: 'relative'
        },
        iframe: {
            width: '100%',
            minHeight: '1200px',
            height: '100%',
            border: 'none',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        },
        header: {
            padding: '16px',
            borderBottom: '1px solid #e0e0e0',
            backgroundColor: '#f5f5f5'
        }
    };

    return (
        <Box style={styles.container}>

            {isLoading && (
                <Dimmer message='Loading content from server...' />
            )}

            {!isLoading && fetchError && (
                <Box style={{
                    padding: '20px',
                    textAlign: 'center',
                    color: '#d32f2f'
                }}>
                    <Typography variant='h6' gutterBottom>
                        ❌ Error loading content
                    </Typography>
                    <Typography variant='body2' style={{ marginBottom: '16px' }}>
                        {fetchError}
                    </Typography>
                    <Typography variant='caption' color='textSecondary'>
                        Please check that your server is running and configured for CORS
                    </Typography>
                </Box>
            )}

            {!isLoading && !fetchError && iframeUrl && (
                <iframe
                    src={iframeUrl}
                    style={styles.iframe}
                    onLoad={handleIframeLoad}
                    onError={handleIframeError}
                    title={`Matrix and Leasing for Property ${property_id}`}
                    sandbox='allow-same-origin allow-scripts allow-popups allow-forms allow-modals'
                />
            )}
        </Box>
    );
};

const mapStateToProps = state => ({
    authorization: state.auth.authorization
});

export default connect(mapStateToProps)(MatrixV2);
